import { DATASET } from '@utils/constants';

export const createQuery = (
  metricList: string[] = [],
  interval,
  granularity = 'ALL',
  filter = [] as any[][],
  options = {},
) => {
  const query = {
    type: 'timeseries',
    dataset: DATASET,
    granularity: granularity,
    options: {
      withTotals: true,
      ...(options || {}),
    },
    interval,
    filter,
    metrics: metricList,
    context: window.conviva.context,
  };

  return {
    queries: [query],
  };
};
